import React, {Component} from 'react'

// import './Home.css'

class NotFound extends Component {
  render() {
    return(
      <p>
        Path not found!
      </p>
    )
  }
}

export default NotFound



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFound.js